export const cartProductSelector = (state) => state.cartProduct;
export const cartProductCartSelector = (state) => state.cartProduct?.configuration?.cart;
export const cartProductFulfillmentSelector = (state) => state.cartProduct?.fulfillment;
export const cartProductMediaSelector = (state) => state.cartProduct?.media;
